export default "<whist-table [players]=\"players\" [humanPlayerIndex]=\"3\"></whist-table>\n<!-- [openHand]=\"true\" -->"